// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Global Styles - 2024 Design System */

/* Import Modern Fonts */

/* CSS Custom Properties for Design System */
:root {
  /* Color Palette */
  --primary-50: #f0f4ff;
  --primary-100: #e0e7ff;
  --primary-200: #c7d2fe;
  --primary-300: #a5b4fc;
  --primary-400: #818cf8;
  --primary-500: #6366f1;
  --primary-600: #4f46e5;
  --primary-700: #4338ca;
  --primary-800: #3730a3;
  --primary-900: #312e81;

  --secondary-50: #f0fdfa;
  --secondary-100: #ccfbf1;
  --secondary-200: #99f6e4;
  --secondary-300: #5eead4;
  --secondary-400: #2dd4bf;
  --secondary-500: #14b8a6;
  --secondary-600: #0d9488;
  --secondary-700: #0f766e;
  --secondary-800: #115e59;
  --secondary-900: #134e4a;

  --neutral-50: #fafaf9;
  --neutral-100: #f5f5f4;
  --neutral-200: #e7e5e4;
  --neutral-300: #d6d3d1;
  --neutral-400: #a8a29e;
  --neutral-500: #78716c;
  --neutral-600: #57534e;
  --neutral-700: #44403c;
  --neutral-800: #292524;
  --neutral-900: #1c1917;

  --success-500: #22c55e;
  --warning-500: #f59e0b;
  --error-500: #ef4444;

  /* Spacing Scale */
  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;
  --space-16: 4rem;
  --space-20: 5rem;
  --space-24: 6rem;

  /* Border Radius */
  --radius-xs: 0.25rem;
  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --radius-3xl: 2rem;
  --radius-full: 9999px;

  /* Shadows */
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  
  /* Glassmorphism */
  --glass-bg: rgba(255, 255, 255, 0.1);
  --glass-border: rgba(255, 255, 255, 0.2);
  --glass-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  
  /* Gradients */
  --gradient-primary: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);
  --gradient-secondary: linear-gradient(135deg, var(--secondary-500) 0%, var(--secondary-600) 100%);
  --gradient-brand: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-500) 50%, var(--secondary-500) 100%);
  --gradient-glass: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  
  /* Animations */
  --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-normal: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  /* Z-Index Scale */
  --z-dropdown: 1000;
  --z-sticky: 1020;
  --z-fixed: 1030;
  --z-modal-backdrop: 1040;
  --z-modal: 1050;
  --z-popover: 1060;
  --z-tooltip: 1070;
}

/* Reset and Base Styles */
* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  background: linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
  color: var(--neutral-900);
  line-height: 1.6;
}

/* Modern Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--neutral-100);
  border-radius: var(--radius-full);
}

::-webkit-scrollbar-thumb {
  background: var(--neutral-300);
  border-radius: var(--radius-full);
  -webkit-transition: background var(--transition-normal);
  transition: background var(--transition-normal);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--neutral-400);
}

/* Utility Classes */

/* Glassmorphism Effects */
.glass-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--radius-xl);
  box-shadow: var(--glass-shadow);
}

.glass-nav {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Modern Gradients */
.gradient-bg {
  background: var(--gradient-brand);
}

.gradient-text {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Floating Elements */
.floating-card {
  transform: translateY(0);
  transition: all var(--transition-slow);
  box-shadow: var(--shadow-lg);
}

.floating-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-2xl);
}

/* Modern Buttons */
.btn-modern {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6);
  border-radius: var(--radius-lg);
  font-weight: 500;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
}

.btn-modern::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn-modern:hover::before {
  left: 100%;
}

.btn-primary {
  background: var(--gradient-primary);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.25);
}

.btn-secondary {
  background: var(--gradient-secondary);
  color: white;
}

.btn-ghost {
  background: transparent;
  color: var(--primary-600);
  border: 1px solid var(--primary-300);
}

.btn-ghost:hover {
  background: var(--primary-50);
  border-color: var(--primary-500);
}

/* Status Indicators */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.status-success {
  background: rgba(34, 197, 94, 0.1);
  color: #15803d;
}

.status-success::before {
  background: var(--success-500);
}

.status-warning {
  background: rgba(245, 158, 11, 0.1);
  color: #92400e;
}

.status-warning::before {
  background: var(--warning-500);
}

.status-error {
  background: rgba(239, 68, 68, 0.1);
  color: #b91c1c;
}

.status-error::before {
  background: var(--error-500);
}

.status-neutral {
  background: var(--neutral-100);
  color: var(--neutral-700);
}

.status-neutral::before {
  background: var(--neutral-400);
}

/* Modern Cards */
.modern-card {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: var(--radius-xl);
  padding: var(--space-6);
  box-shadow: var(--shadow-lg);
  transition: all var(--transition-slow);
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-2xl);
  border-color: rgba(99, 102, 241, 0.2);
}

/* Stats Cards */
.stats-card {
  background: var(--gradient-glass);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--radius-2xl);
  padding: var(--space-8);
  text-align: center;
  transition: all var(--transition-slow);
}

.stats-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.15);
}

.stats-number {
  font-size: 3rem;
  font-weight: 800;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  margin-bottom: var(--space-2);
}

.stats-label {
  color: var(--neutral-600);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.875rem;
}

/* Modern Tables */
.modern-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.modern-table th {
  background: rgba(99, 102, 241, 0.05);
  padding: var(--space-4) var(--space-6);
  text-align: left;
  font-weight: 600;
  color: var(--neutral-700);
  border-bottom: 1px solid rgba(99, 102, 241, 0.1);
}

.modern-table td {
  padding: var(--space-4) var(--space-6);
  border-bottom: 1px solid var(--neutral-200);
  transition: background var(--transition-fast);
}

.modern-table tr:hover td {
  background: rgba(99, 102, 241, 0.03);
}

.modern-table tr:last-child td {
  border-bottom: none;
}

/* Form Elements */
.modern-input {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--neutral-300);
  border-radius: var(--radius-lg);
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  font-family: inherit;
  font-size: 1rem;
  transition: all var(--transition-normal);
}

.modern-input:focus {
  outline: none;
  border-color: var(--primary-500);
  background: white;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.modern-input::placeholder {
  color: var(--neutral-400);
}

/* Loading States */
.loading-shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

/* Micro-interactions */
.bounce-in {
  animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@keyframes bounceIn {
  0% {
    transform: scale(0.3);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  :root {
    --space-4: 0.75rem;
    --space-6: 1rem;
    --space-8: 1.5rem;
  }
  
  .modern-card {
    padding: var(--space-4);
  }
  
  .stats-card {
    padding: var(--space-6);
  }
  
  .stats-number {
    font-size: 2rem;
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  :root {
    --glass-bg: rgba(0, 0, 0, 0.2);
    --glass-border: rgba(255, 255, 255, 0.1);
  }
  
  body {
    background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%);
    color: white;
  }
  
  .modern-card {
    background: rgba(26, 26, 46, 0.8);
    border-color: rgba(255, 255, 255, 0.1);
  }
  
  .modern-input {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.2);
    color: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/modern-global.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C,wBAAwB;;AAGxB,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;;EAEpB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;;EAErB,YAAY;EACZ,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;;EAEnD,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;EACxC,oDAAoD;;EAEpD,cAAc;EACd,2FAA2F;EAC3F,iGAAiG;EACjG,mHAAmH;EACnH,sGAAsG;;EAEtG,eAAe;EACf,qDAAqD;EACrD,sDAAsD;EACtD,oDAAoD;;EAEpD,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,yFAAyF;EACzF,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,uDAA+C;EAA/C,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oBAAoB;;AAEpB,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0CAA0C;EAC1C,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE,+DAA+D;AACjE;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;IAC9B,wCAAwC;EAC1C;;EAEA;IACE,6DAA6D;IAC7D,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,sCAAsC;EACxC;;EAEA;IACE,qCAAqC;IACrC,sCAAsC;IACtC,YAAY;EACd;AACF","sourcesContent":["/* Modern Global Styles - 2024 Design System */\n\n/* Import Modern Fonts */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');\n\n/* CSS Custom Properties for Design System */\n:root {\n  /* Color Palette */\n  --primary-50: #f0f4ff;\n  --primary-100: #e0e7ff;\n  --primary-200: #c7d2fe;\n  --primary-300: #a5b4fc;\n  --primary-400: #818cf8;\n  --primary-500: #6366f1;\n  --primary-600: #4f46e5;\n  --primary-700: #4338ca;\n  --primary-800: #3730a3;\n  --primary-900: #312e81;\n\n  --secondary-50: #f0fdfa;\n  --secondary-100: #ccfbf1;\n  --secondary-200: #99f6e4;\n  --secondary-300: #5eead4;\n  --secondary-400: #2dd4bf;\n  --secondary-500: #14b8a6;\n  --secondary-600: #0d9488;\n  --secondary-700: #0f766e;\n  --secondary-800: #115e59;\n  --secondary-900: #134e4a;\n\n  --neutral-50: #fafaf9;\n  --neutral-100: #f5f5f4;\n  --neutral-200: #e7e5e4;\n  --neutral-300: #d6d3d1;\n  --neutral-400: #a8a29e;\n  --neutral-500: #78716c;\n  --neutral-600: #57534e;\n  --neutral-700: #44403c;\n  --neutral-800: #292524;\n  --neutral-900: #1c1917;\n\n  --success-500: #22c55e;\n  --warning-500: #f59e0b;\n  --error-500: #ef4444;\n\n  /* Spacing Scale */\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n  --space-20: 5rem;\n  --space-24: 6rem;\n\n  /* Border Radius */\n  --radius-xs: 0.25rem;\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  --radius-3xl: 2rem;\n  --radius-full: 9999px;\n\n  /* Shadows */\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  \n  /* Glassmorphism */\n  --glass-bg: rgba(255, 255, 255, 0.1);\n  --glass-border: rgba(255, 255, 255, 0.2);\n  --glass-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);\n  \n  /* Gradients */\n  --gradient-primary: linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%);\n  --gradient-secondary: linear-gradient(135deg, var(--secondary-500) 0%, var(--secondary-600) 100%);\n  --gradient-brand: linear-gradient(135deg, var(--primary-600) 0%, var(--primary-500) 50%, var(--secondary-500) 100%);\n  --gradient-glass: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);\n  \n  /* Animations */\n  --transition-fast: 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-normal: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-slow: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  \n  /* Z-Index Scale */\n  --z-dropdown: 1000;\n  --z-sticky: 1020;\n  --z-fixed: 1030;\n  --z-modal-backdrop: 1040;\n  --z-modal: 1050;\n  --z-popover: 1060;\n  --z-tooltip: 1070;\n}\n\n/* Reset and Base Styles */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  background: linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%);\n  min-height: 100vh;\n  margin: 0;\n  padding: 0;\n  color: var(--neutral-900);\n  line-height: 1.6;\n}\n\n/* Modern Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--neutral-100);\n  border-radius: var(--radius-full);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--neutral-300);\n  border-radius: var(--radius-full);\n  transition: background var(--transition-normal);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--neutral-400);\n}\n\n/* Utility Classes */\n\n/* Glassmorphism Effects */\n.glass-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--glass-shadow);\n}\n\n.glass-nav {\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Modern Gradients */\n.gradient-bg {\n  background: var(--gradient-brand);\n}\n\n.gradient-text {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Floating Elements */\n.floating-card {\n  transform: translateY(0);\n  transition: all var(--transition-slow);\n  box-shadow: var(--shadow-lg);\n}\n\n.floating-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-2xl);\n}\n\n/* Modern Buttons */\n.btn-modern {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-6);\n  border-radius: var(--radius-lg);\n  font-weight: 500;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-modern::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.btn-modern:hover::before {\n  left: 100%;\n}\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.25);\n}\n\n.btn-secondary {\n  background: var(--gradient-secondary);\n  color: white;\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--primary-600);\n  border: 1px solid var(--primary-300);\n}\n\n.btn-ghost:hover {\n  background: var(--primary-50);\n  border-color: var(--primary-500);\n}\n\n/* Status Indicators */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-1);\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.status-badge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.status-success {\n  background: rgba(34, 197, 94, 0.1);\n  color: #15803d;\n}\n\n.status-success::before {\n  background: var(--success-500);\n}\n\n.status-warning {\n  background: rgba(245, 158, 11, 0.1);\n  color: #92400e;\n}\n\n.status-warning::before {\n  background: var(--warning-500);\n}\n\n.status-error {\n  background: rgba(239, 68, 68, 0.1);\n  color: #b91c1c;\n}\n\n.status-error::before {\n  background: var(--error-500);\n}\n\n.status-neutral {\n  background: var(--neutral-100);\n  color: var(--neutral-700);\n}\n\n.status-neutral::before {\n  background: var(--neutral-400);\n}\n\n/* Modern Cards */\n.modern-card {\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: var(--radius-xl);\n  padding: var(--space-6);\n  box-shadow: var(--shadow-lg);\n  transition: all var(--transition-slow);\n}\n\n.modern-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-2xl);\n  border-color: rgba(99, 102, 241, 0.2);\n}\n\n/* Stats Cards */\n.stats-card {\n  background: var(--gradient-glass);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--radius-2xl);\n  padding: var(--space-8);\n  text-align: center;\n  transition: all var(--transition-slow);\n}\n\n.stats-card:hover {\n  transform: translateY(-6px) scale(1.02);\n  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.15);\n}\n\n.stats-number {\n  font-size: 3rem;\n  font-weight: 800;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  line-height: 1;\n  margin-bottom: var(--space-2);\n}\n\n.stats-label {\n  color: var(--neutral-600);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-size: 0.875rem;\n}\n\n/* Modern Tables */\n.modern-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-xl);\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n\n.modern-table th {\n  background: rgba(99, 102, 241, 0.05);\n  padding: var(--space-4) var(--space-6);\n  text-align: left;\n  font-weight: 600;\n  color: var(--neutral-700);\n  border-bottom: 1px solid rgba(99, 102, 241, 0.1);\n}\n\n.modern-table td {\n  padding: var(--space-4) var(--space-6);\n  border-bottom: 1px solid var(--neutral-200);\n  transition: background var(--transition-fast);\n}\n\n.modern-table tr:hover td {\n  background: rgba(99, 102, 241, 0.03);\n}\n\n.modern-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Form Elements */\n.modern-input {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  border: 1px solid var(--neutral-300);\n  border-radius: var(--radius-lg);\n  background: rgba(255, 255, 255, 0.5);\n  backdrop-filter: blur(10px);\n  font-family: inherit;\n  font-size: 1rem;\n  transition: all var(--transition-normal);\n}\n\n.modern-input:focus {\n  outline: none;\n  border-color: var(--primary-500);\n  background: white;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.modern-input::placeholder {\n  color: var(--neutral-400);\n}\n\n/* Loading States */\n.loading-shimmer {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Micro-interactions */\n.bounce-in {\n  animation: bounceIn 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n@keyframes bounceIn {\n  0% {\n    transform: scale(0.3);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.05);\n  }\n  70% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  :root {\n    --space-4: 0.75rem;\n    --space-6: 1rem;\n    --space-8: 1.5rem;\n  }\n  \n  .modern-card {\n    padding: var(--space-4);\n  }\n  \n  .stats-card {\n    padding: var(--space-6);\n  }\n  \n  .stats-number {\n    font-size: 2rem;\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  :root {\n    --glass-bg: rgba(0, 0, 0, 0.2);\n    --glass-border: rgba(255, 255, 255, 0.1);\n  }\n  \n  body {\n    background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%);\n    color: white;\n  }\n  \n  .modern-card {\n    background: rgba(26, 26, 46, 0.8);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  .modern-input {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.2);\n    color: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
